import breadcrumbStyle from '../start/BreadcrumbNavigation.less';
import { ContextService } from '../../services/context_service';
import { DateneingabeCO2Komplex } from './DateneingabeCO2Komplex';
import { findDOMNode } from 'react-dom';
import formStyle from '../../core/forms/style/WForm.less';
import { getDefaultHelpIcon } from '../../helpers/getDefaultHelpIcon';
import { getNoStandortMessage } from '../datenauswertung/elements/getNoStandortMessage';
import { getStandorte } from '../../helpers/getStandorte';
import { getStandorteGruppenTabRoutings } from './functions/StandorteGruppen';;
import { getVeranstaltungen } from '../../helpers/getVeranstaltungen'
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { VeranstaltungsAuswahl } from '../../helpers/VeranstaltungsAuswahl';

interface DateneingabeCO2KomplexTabsProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortSelected: any;
    scrollLeft: number;
}

interface DateneingabeCO2KomplexTabsState {
    tabIndex: number;
    tabIndex2: number;
    veranstaltungSelected: any;
}

export class DateneingabeCO2KomplexTabs extends
    React.Component<DateneingabeCO2KomplexTabsProps, DateneingabeCO2KomplexTabsState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: 0,
            tabIndex2: 0,
            veranstaltungSelected: null
        };
        this.onScroll = this.onScroll.bind(this);
    }

    @lazyInject(ContextService) private contextService: ContextService;

    private mapNode: any = {};
    private scrollPositions: any = {}; // Nicht im State, da wir uns nur die Positionen merken wollen und nicht "reagieren"
    private offsetAuswahl: number = 0;

    componentDidMount(): void {
        this.checkRouting();
        this.checkTabIndex();
    }

    componentDidUpdate(prevProps: any): void {
        if (this.props.routing !== prevProps.routing) {
            this.checkRouting();
            this.checkTabIndex();
        }
    }

    checkTabIndex(): void {
        const tabIndex = this.contextService.get('tabIdxDateneingabeCO2Komplex') || 0;
        const tabIndex2 = this.contextService.get(`tabIdxDateneingabeCO2Komplex_${tabIndex}`) || 0;
        if (tabIndex !== this.state.tabIndex) {
            this.setState({ tabIndex });
        }
        if (tabIndex2 !== this.state.tabIndex2) {
            this.setState({ tabIndex2 });
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        const tabName: string = RoutingIDs.TABS_DATENEINGABE_CO2_KOMPLEX;
        if (routing.path && routing.path[tabName] !== undefined) {
            if (routing.path.terminateOn === tabName) {
                const veranstaltungSelected: any = routing.standort ? (getVeranstaltungen(this.props.data) || []).find((item: any) => item.tid === routing.standort) : null;
                if (veranstaltungSelected && veranstaltungSelected !== this.state.veranstaltungSelected) {
                    this.setState({ veranstaltungSelected });
                }
            }
            if (this.state.tabIndex === routing.path[tabName]) {
                if (routing.path.terminateOn === tabName) {
                    this.props.onRoutingChange({});
                }
            } else {
                this.setTabIndex(routing.path[tabName], routing);
            }
        }
        const tabName2: string = RoutingIDs.TABS_STANDORTE_GRUPPE_ITEM;
        if (routing.path && routing.path[tabName2] !== undefined) {
            // if ((routing.path.terminateOn || null) === tabName2) {
            //     this.props.onRoutingChange({});
            // }
            // this.setTabIndex2(routing.path[tabName2], routing);
            if (this.state.tabIndex2 === routing.path[tabName2]) {
                if (routing.path.terminateOn === tabName2) {
                    this.props.onRoutingChange({});
                }
            } else {
                this.setTabIndex2(routing.path[tabName2], routing);
            }
        }
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void): void {
        if (this.state.tabIndex !== tabIndex) {
            const routing: any = JSON.parse(JSON.stringify(this.props.routing || {}));
            const tabName: string = RoutingIDs.TABS_DATENEINGABE_CO2_KOMPLEX;
            if (routing.path && routing.path[tabName] === undefined) {
                // init default tabIndex
                routing.path[tabName] = this.state.tabIndex;
                this.props.onRoutingChange(routing);
            }
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set('tabIdxDateneingabeCO2Komplex', tabIndex);
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }, 0);
        }
    }

    setTabIndex2(tabIndex2: number, tabRouting: any, callback?: () => void): void {
        if (this.state.tabIndex2 !== tabIndex2) {
            const routing: any = JSON.parse(JSON.stringify(this.props.routing || {}));
            const tabName2: string = RoutingIDs.TABS_STANDORTE_GRUPPE_ITEM;
            if (routing.path && routing.path[tabName2] === undefined) {
                // init default tabIndex2
                routing.path[tabName2] = this.state.tabIndex2;
                this.props.onRoutingChange(routing);
            }
            setTimeout(() => {
                this.setState({ tabIndex2 }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set(`tabIdxDateneingabeCO2Komplex_${this.state.tabIndex}`, tabIndex2);
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }, 0);
        }
    }

    onScroll(tid: number, evt: any): void {
        const scrollTop = evt.target.scrollTop;
        this.scrollPositions[tid] = scrollTop;
        // const scrollTopMax = evt.target.scrollTopMax;
        // if (scrollTopMax > 0) { // Beim Unmounten kommt das Event mit scrollTop und scrollTopMax == 0 --> abfangen
        //     console.log('Scroll ' + tid, scrollTop, scrollTopMax);
        //     this.scrollPositions[tid] = scrollTop;
        // }
    }

    render(): JSX.Element {
        const data: any = this.props.data || {};
        const standorte: any[] = getStandorte(this.props.data) || [];
        if (standorte.length === 0) {
            return getNoStandortMessage();
        }

        const basisRouting = RoutingIDs.ROUTE_DATENEINGABE_CO2_KOMPLEX;
        const basisTab = RoutingIDs.TABS_DATENEINGABE_CO2_KOMPLEX;
        const tabRoutings = getStandorteGruppenTabRoutings(this.props.data, basisRouting, basisTab);

        const disableVeranstaltungen: boolean = !(data[IDs.ENT_KONFIGURATION] || []).some((param: any) => param.veranstaltungen_orig === 1);
        if (!disableVeranstaltungen) {
            // Tab Veranstaltungen
            tabRoutings.push({
                name: 'Veranstaltungen',
                path: {
                    ...basisRouting,
                    [basisTab]: tabRoutings.length,
                    terminateOn: basisTab
                }
            });
        }

        return (
            <Tabs
                className='tabs-co2'
                style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}
                selectedIndex={this.state.tabIndex}
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, tabRoutings[tabIndex])}
            >
                <TabList style={{ display: 'none' }}>
                    {tabRoutings.map((r: any, idx: number) =>
                        <Tab key={`tab-${idx}`}>{r.name}</Tab>
                    )}
                </TabList>
                {/*tabRoutings.map((r: any, idx: number) => this.renderTabPanel(idx, r))*/}
                {tabRoutings.map((r: any, idx: number) =>
                    r.name !== 'Veranstaltungen' ? this.renderTabPanel(idx, r) : this.renderTabPanelVeranstaltung(tabRoutings.length - 1)
                )}
            </Tabs>
        );
    }

    renderTabPanel(idx: number, routing: any): JSX.Element {
        if (Array.isArray(routing.children)) {
            return this.renderTabPanelGruppe(idx, routing);
        } else {
            return this.renderTabPanelSingle(idx, undefined, routing);
        }
    }

    renderTabPanelGruppe(idx: number, routing: any): JSX.Element {
        const tabRoutings = routing && routing.path && Array.isArray(routing.children) ? routing.children : [];
        return <TabPanel
            key={`panel-${idx}`}
            style={{
                flexDirection: 'column', display: 'flex', minHeight: 0,
                flex: this.state.tabIndex === idx ? 1 : 0
            }}
        >
            <Tabs
                className={'tabs-co2'}
                style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}
                selectedIndex={this.state.tabIndex2}
                onSelect={(tabIndex2, lastIndex, event) => this.setTabIndex2(tabIndex2, tabRoutings[tabIndex2])}
            >
                <TabList style={{display: 'none'}}>
                    {tabRoutings.map((r: any, idx2: number) => <Tab key={`tab-${idx}-${idx2}`}>{r.name}</Tab>)}
                </TabList>
                {tabRoutings.map((r: any, idx2: number) => this.renderTabPanelSingle(idx, idx2, r))}
            </Tabs >
        </TabPanel>;
    }

    renderTabPanelSingle(idx: number, idx2: number, routing: any): JSX.Element {
        const dataRow = routing.dataRow || {};
        return <TabPanel
            key={idx2 >= 0 ? `panel-${idx}-${idx2}` : `panel-${idx}`}
            onScroll={(evt: any) => this.onScroll(dataRow.tid, evt)}
            style={{
                flexDirection: 'column', display: 'flex', minHeight: 0,
                flex: this.state.tabIndex === idx && (idx2 >= 0 ? this.state.tabIndex2 === idx2 : true) ? 1 : 0
            }}
            ref={(tab: any) => {
                if (tab !== null) {
                    const node: any = findDOMNode(tab);
                    node.scrollTop = this.scrollPositions[dataRow.tid];
                    this.mapNode[dataRow.tid] = node;
                }
            }}
        >
            {getDefaultHelpIcon('pageScope3Daten', 'Hilfe zu den Scope 3 - Daten', this.props.data, null, { backgroundColor: '#00b050' }, null, breadcrumbStyle.breadcrumb_infoicon)}
            <DateneingabeCO2Komplex
                data={this.props.data}
                standortSelected={dataRow}
                onRoutingChange={this.props.onRoutingChange}
                routing={this.props.routing}
                scrollLeft={this.props.scrollLeft}
                getScrollTop={() => this.scrollPositions[dataRow.tid]}
                setScrollTop={(scrollTop: number) => {
                    const node = this.mapNode[dataRow.tid];
                    if (node) {
                        node.scrollTop = scrollTop;
                    }
                }}
            />
        </TabPanel>;
    }

    renderTabPanelVeranstaltung(idx: number): JSX.Element {
        return <TabPanel
            key={`panel-${idx}`}
            onScroll={(evt: any) => this.state.veranstaltungSelected ? this.onScroll(-1, evt) : null}
            style={{
                flexDirection: 'column', display: 'flex', minHeight: 0,
                flex: this.state.tabIndex === idx ? 1 : 0
            }}
            ref={(tab: any) => {
                if (tab !== null) {
                    const node: any = findDOMNode(tab);
                    if (this.state.veranstaltungSelected) {
                        node.scrollTop = this.scrollPositions[-1];
                        this.mapNode[-1] = node;
                    }
                }
            }}
        >
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                <div
                    className={formStyle.formCompact}
                    ref={(ref: any) => {
                        if (ref && +ref.clientHeight !== this.offsetAuswahl) {
                            this.offsetAuswahl = ref.clientHeight;
                        }
                    }}
                >
                    <VeranstaltungsAuswahl
                        data={this.props.data}
                        veranstaltung={this.state.veranstaltungSelected}
                        onVeranstaltungSelect={(veranstaltung: any) => this.setState({ veranstaltungSelected: veranstaltung })}
                    />
                </div>
                {this.state.veranstaltungSelected
                    ? <DateneingabeCO2Komplex
                        key={`DateneingabeCO2Komplex_${this.state.veranstaltungSelected.tid}`}
                        data={this.props.data}
                        standortSelected={this.state.veranstaltungSelected}
                        onRoutingChange={this.props.onRoutingChange}
                        routing={this.props.routing}
                        scrollLeft={this.props.scrollLeft}
                        style={{ marginTop: this.offsetAuswahl }}
                        getScrollTop={() => this.scrollPositions[-1]}
                        setScrollTop={(scrollTop: number) => {
                            const node = this.mapNode[-1];
                            if (node) {
                                node.scrollTop = scrollTop;
                            }
                        }}
                    />
                    : <div>Bitte eine Veranstaltung wählen!</div>
                }
            </div>
        </TabPanel>;
    }
}
